const STABILITY_MARKER = '__crmRuntimeStabilityInstalled';
const REMOVE_CHILD_MARKER = '__crmSafeRemoveChildInstalled';

export const fallbackStructuredClone = (value) => {
	if (value === undefined) {
		return undefined;
	}

	try {
		return JSON.parse(JSON.stringify(value));
	} catch (error) {
		return value;
	}
};

export const installStructuredClonePolyfill = (target = (typeof globalThis !== 'undefined' ? globalThis : null)) => {
	if (!target || typeof target.structuredClone === 'function') {
		return false;
	}

	target.structuredClone = fallbackStructuredClone;
	return true;
};

const shouldIgnoreRemoveChildError = (error) => {
	if (!error) {
		return false;
	}

	if (error.name === 'NotFoundError') {
		return true;
	}

	const message = String(error.message || '').toLowerCase();
	return message.includes('removechild') && message.includes('not a child');
};

export const installSafeRemoveChildGuard = (targetWindow = (typeof window !== 'undefined' ? window : null)) => {
	const nodePrototype = targetWindow && targetWindow.Node && targetWindow.Node.prototype;

	if (!nodePrototype || nodePrototype[REMOVE_CHILD_MARKER]) {
		return false;
	}

	const originalRemoveChild = nodePrototype.removeChild;

	if (typeof originalRemoveChild !== 'function') {
		return false;
	}

	nodePrototype.removeChild = function safeRemoveChild(childNode) {
		if (!childNode || childNode.parentNode !== this) {
			return childNode;
		}

		try {
			return originalRemoveChild.call(this, childNode);
		} catch (error) {
			if (shouldIgnoreRemoveChildError(error)) {
				return childNode;
			}

			throw error;
		}
	};

	nodePrototype[REMOVE_CHILD_MARKER] = true;
	return true;
};

export const installRuntimeStability = () => {
	const target = (typeof globalThis !== 'undefined' ? globalThis : null);

	if (!target || target[STABILITY_MARKER]) {
		return false;
	}

	installStructuredClonePolyfill(target);
	installSafeRemoveChildGuard(typeof window !== 'undefined' ? window : null);

	target[STABILITY_MARKER] = true;
	return true;
};

